class FailureResponse {
  /**
   * L'errore è gestito e rappresenta una casistica delle problematiche riscontrabili con il provider di autenticazione.
   * Es. credenziali errate, utente non attivo, ecc.
   *
   * Se handled è false sono cazzi amari.
   */
  handled: boolean;
  /**
   * Il messaggio di errore.
   * Può essere codifica con iam.error.<codice-errore> oppure un messaggio di errore generico.
   */
  message: string;

  constructor(handled: boolean, message: string) {
    this.handled = handled;
    this.message = message;
  }

  static handled(message: string): FailureResponse {
    return new FailureResponse(true, message);
  }

  static unhandled(message: string): FailureResponse {
    return new FailureResponse(false, message);
  }
}

export { FailureResponse };
